<div
  class="datepicker-container"
  [class.range-mode]="selectionMode === 'range' || selectionMode === 'extended' || selectionMode === 'period'"
  [class.dp-compact]="small"
>
  <!-- Input with icon inside -->
  <div class="datepicker-input-wrapper" [class.dp-sm]="small">
    <input
      type="text"
      class="form-control datepicker-input"
      [class.form-control-sm]="small"
      [class.dp-invalid]="invalid"
      [placeholder]="placeholder"
      [value]="inputValue"
      (focus)="onInputFocus($event)"
      (click)="onInputClick($event)"
      (keydown)="onInputKeyDown($event)"
      (blur)="onInputChange()"
      [disabled]="disabled"
      [readonly]="isInputReadonly"
      autocomplete="off"
    />
    <button class="datepicker-toggle-btn" type="button"
            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
            (click)="toggleCalendar($event)"
            [disabled]="disabled" tabindex="-1">
      <i class="fa fa-calendar"></i>
    </button>
  </div>

  <!-- Static Mode Dropdown -->
  @if (static && isOpen) {
    <ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
  }
</div>

<!-- Calendar Dropdown Template (rendered in body) -->
<ng-template #dropdownTemplate>
  <div
    class="calendar-dropdown"
    [ngStyle]="dropdownStyle"
    (click)="$event.stopPropagation()"
    [class.period-mode]="selectionMode === 'period'"
  >
    <div class="calendar-layout" [class.d-flex]="selectionMode === 'extended'">
      <!-- Sidebar for Extended Mode -->
      @if (selectionMode === 'extended') {
        <div class="calendar-sidebar">
          @for (preset of presets; track preset.value) {
            <button type="button" class="preset-item" [class.active]="activePreset === preset.value" (click)="selectPreset(preset.value)">
              {{ preset.label }}
            </button>
          }
        </div>
      }

      <div class="calendar-main" [class.flex-grow-1]="selectionMode === 'extended'">
        @if (selectionMode === 'period') {
          <div class="d-flex gx-4">
            <!-- LEFT PANE -->
            <div class="period-pane border-end pe-3">
              <div class="text-muted small fw-bold text-center mb-2">From Date</div>
              <!-- Header -->
              <div class="calendar-header">
                @if (periodStartViewMode === 'day' || periodStartViewMode === 'month') {
                  <button
                    type="button"
                    class="btn btn-sm btn-light nav-btn"
                    (click)="prevPeriodView('start')"
                    [class.invisible]="!canGoPeriodPrev('start')"
                  >
                    <i class="fa fa-chevron-left"></i>
                  </button>
                } @else {
                  <button
                    type="button"
                    class="btn btn-sm btn-light nav-btn"
                    (click)="prevPeriodYearRange('start')"
                    [class.invisible]="!canGoPeriodPrev('start')"
                  >
                    <i class="fa fa-chevron-left"></i>
                  </button>
                }

                <div class="calendar-title-group mx-auto">
                  <button
                    type="button"
                    class="calendar-title-btn"
                    [class.active]="false"
                    (click)="togglePeriodTitleView('start')"
                  >
                    @if (periodStartViewMode === 'day') {
                      {{ periodStartViewDate.format('MMMM YYYY') }}
                    } @else if (periodStartViewMode === 'month') {
                      {{ periodStartViewDate.format('YYYY') }}
                    } @else {
                      {{ periodStartYearRangeStart }} - {{ periodStartYearRange[periodStartYearRange.length - 1] }}
                    }
                  </button>
                </div>

                @if (periodStartViewMode === 'day' || periodStartViewMode === 'month') {
                  <button
                    type="button"
                    class="btn btn-sm btn-light nav-btn"
                    (click)="nextPeriodView('start')"
                    [class.invisible]="!canGoPeriodNext('start')"
                  >
                    <i class="fa fa-chevron-right"></i>
                  </button>
                } @else {
                  <button
                    type="button"
                    class="btn btn-sm btn-light nav-btn"
                    (click)="nextPeriodYearRange('start')"
                    [class.invisible]="!canGoPeriodNext('start')"
                  >
                    <i class="fa fa-chevron-right"></i>
                  </button>
                }
              </div>

              <!-- Views -->
              @if (periodStartViewMode === 'year') {
                <div class="year-picker">
                  <div class="year-grid">
                    @for (year of periodStartYearRange; track year) {
                      <button
                        type="button"
                        class="year-item"
                        [class.selected]="year === periodStartViewDate.year()"
                        [class.disabled]="isPeriodYearDisabled(year, 'start')"
                        [disabled]="isPeriodYearDisabled(year, 'start')"
                        (click)="selectPeriodYear('start', year, $event)"
                      >
                        {{ year }}
                      </button>
                    }
                  </div>
                </div>
              }
              @if (periodStartViewMode === 'month') {
                <div class="month-picker">
                  @for (month of months; track month.value) {
                    <button
                      type="button"
                      class="month-item"
                      [class.selected]="month.value === periodStartViewDate.month()"
                      [class.disabled]="isPeriodMonthDisabled(month.value, 'start')"
                      [disabled]="isPeriodMonthDisabled(month.value, 'start')"
                      (click)="selectPeriodMonth('start', month.value, $event)"
                    >
                      {{ month.name }}
                    </button>
                  }
                </div>
              }
              @if (periodStartViewMode === 'day') {
                <div class="calendar-weekdays">
                  @for (day of weekdays; track day) {
                    <span class="weekday">{{ day }}</span>
                  }
                </div>
                <div class="calendar-days">
                  @for (day of periodStartCalendarDays; track day.date.toString()) {
                    <button
                      type="button"
                      class="calendar-day"
                      [class.other-month]="!day.isCurrentMonth"
                      [class.today]="day.isToday"
                      [class.selected]="day.isSelected"
                      [class.disabled]="day.isDisabled"
                      [class.in-range]="day.isInRange"
                      [class.range-start]="day.isRangeStart"
                      [class.range-end]="day.isRangeEnd"
                      [disabled]="day.isDisabled"
                      (click)="selectPeriodDate('start', day)"
                    >
                      {{ day.day }}
                    </button>
                  }
                </div>
              }
            </div>

            <!-- RIGHT PANE -->
            <div class="period-pane ps-3" [class.disabled-pane]="!rangeStart || rangeEnd">
              <div class="text-muted small fw-bold text-center mb-2">To Date</div>
              <!-- Header -->
              <div class="calendar-header">
                @if (periodEndViewMode === 'day' || periodEndViewMode === 'month') {
                  <button
                    type="button"
                    class="btn btn-sm btn-light nav-btn"
                    (click)="prevPeriodView('end')"
                    [class.invisible]="!canGoPeriodPrev('end')"
                  >
                    <i class="fa fa-chevron-left"></i>
                  </button>
                } @else {
                  <button
                    type="button"
                    class="btn btn-sm btn-light nav-btn"
                    (click)="prevPeriodYearRange('end')"
                    [class.invisible]="!canGoPeriodPrev('end')"
                  >
                    <i class="fa fa-chevron-left"></i>
                  </button>
                }

                <div class="calendar-title-group mx-auto">
                  <button
                    type="button"
                    class="calendar-title-btn"
                    [class.active]="false"
                    (click)="togglePeriodTitleView('end')"
                  >
                    @if (periodEndViewMode === 'day') {
                      {{ periodEndViewDate.format('MMMM YYYY') }}
                    } @else if (periodEndViewMode === 'month') {
                      {{ periodEndViewDate.format('YYYY') }}
                    } @else {
                      {{ periodEndYearRangeStart }} - {{ periodEndYearRange[periodEndYearRange.length - 1] }}
                    }
                  </button>
                </div>

                @if (periodEndViewMode === 'day' || periodEndViewMode === 'month') {
                  <button
                    type="button"
                    class="btn btn-sm btn-light nav-btn"
                    (click)="nextPeriodView('end')"
                    [class.invisible]="!canGoPeriodNext('end')"
                  >
                    <i class="fa fa-chevron-right"></i>
                  </button>
                } @else {
                  <button
                    type="button"
                    class="btn btn-sm btn-light nav-btn"
                    (click)="nextPeriodYearRange('end')"
                    [class.invisible]="!canGoPeriodNext('end')"
                  >
                    <i class="fa fa-chevron-right"></i>
                  </button>
                }
              </div>

              <!-- Views -->
              @if (periodEndViewMode === 'year') {
                <div class="year-picker">
                  <div class="year-grid">
                    @for (year of periodEndYearRange; track year) {
                      <button
                        type="button"
                        class="year-item"
                        [class.selected]="year === periodEndViewDate.year()"
                        [class.disabled]="isPeriodYearDisabled(year, 'end')"
                        [disabled]="isPeriodYearDisabled(year, 'end')"
                        (click)="selectPeriodYear('end', year, $event)"
                      >
                        {{ year }}
                      </button>
                    }
                  </div>
                </div>
              }
              @if (periodEndViewMode === 'month') {
                <div class="month-picker">
                  @for (month of months; track month.value) {
                    <button
                      type="button"
                      class="month-item"
                      [class.selected]="month.value === periodEndViewDate.month()"
                      [class.disabled]="isPeriodMonthDisabled(month.value, 'end')"
                      [disabled]="isPeriodMonthDisabled(month.value, 'end')"
                      (click)="selectPeriodMonth('end', month.value, $event)"
                    >
                      {{ month.name }}
                    </button>
                  }
                </div>
              }
              @if (periodEndViewMode === 'day') {
                <div class="calendar-weekdays">
                  @for (day of weekdays; track day) {
                    <span class="weekday">{{ day }}</span>
                  }
                </div>
                <div class="calendar-days">
                  @for (day of periodEndCalendarDays; track day.date.toString()) {
                    <button
                      type="button"
                      class="calendar-day"
                      [class.other-month]="!day.isCurrentMonth"
                      [class.today]="day.isToday"
                      [class.selected]="day.isSelected"
                      [class.disabled]="day.isDisabled"
                      [class.in-range]="day.isInRange"
                      [class.range-start]="day.isRangeStart"
                      [class.range-end]="day.isRangeEnd"
                      [disabled]="day.isDisabled"
                      (click)="selectPeriodDate('end', day)"
                    >
                      {{ day.day }}
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        } @else {
          <!-- Header - always visible -->
          <div class="calendar-header">
            @if (viewMode === 'day') {
              <button type="button" class="btn btn-sm btn-light nav-btn" (click)="prevMonth()" [class.invisible]="!canGoPrevMonth()">
                <i class="fa fa-chevron-left"></i>
              </button>
            }
            <div class="calendar-title-group" [class.mx-auto]="viewMode !== 'day'">
              <button type="button" class="calendar-title-btn" [class.active]="viewMode === 'month'" (click)="showMonthPicker()">
                {{ currentMonthName }}
              </button>
              <button type="button" class="calendar-title-btn" [class.active]="viewMode === 'year'" (click)="showYearPicker()">
                {{ currentYear }}
              </button>
            </div>
            @if (viewMode === 'day') {
              <button type="button" class="btn btn-sm btn-light nav-btn" (click)="nextMonth()" [class.invisible]="!canGoNextMonth()">
                <i class="fa fa-chevron-right"></i>
              </button>
            }
          </div>

          <!-- Day Picker View -->
          @if (viewMode === 'day') {
            <!-- Weekday Headers -->
            <div class="calendar-weekdays">
              @for (day of weekdays; track day) {
                <span class="weekday">{{ day }}</span>
              }
            </div>

            <!-- Days Grid -->
            <div class="calendar-days">
              @for (day of calendarDays; track trackByDay($index, day)) {
                <button
                  type="button"
                  class="calendar-day"
                  [class.other-month]="!day.isCurrentMonth"
                  [class.today]="day.isToday"
                  [class.selected]="day.isSelected"
                  [class.disabled]="day.isDisabled"
                  [class.in-range]="day.isInRange"
                  [class.range-start]="day.isRangeStart"
                  [class.range-end]="day.isRangeEnd"
                  [disabled]="day.isDisabled"
                  (click)="selectDate(day)"
                  (mouseenter)="onDayHover(day)"
                >
                  {{ day.day }}
                </button>
              }
            </div>
          }

          <!-- Month Picker View -->
          @if (viewMode === 'month') {
            <div class="month-picker">
              @for (month of months; track month.value) {
                <button
                  type="button"
                  class="month-item"
                  [class.selected]="month.value === viewDate.month()"
                  [class.disabled]="isMonthDisabled(month.value)"
                  [disabled]="isMonthDisabled(month.value)"
                  (click)="selectMonth(month.value, $event)"
                >
                  {{ month.name }}
                </button>
              }
            </div>
          }

          <!-- Year Picker View -->
          @if (viewMode === 'year') {
            <div class="year-picker">
              <div class="year-nav">
                <button type="button" class="btn btn-sm btn-light" (click)="prevYearRange()" [class.invisible]="!canGoPrevYearRange()">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <span class="year-range">{{ yearRangeStart }} - {{ yearRangeEnd }}</span>
                <button type="button" class="btn btn-sm btn-light" (click)="nextYearRange()" [class.invisible]="!canGoNextYearRange()">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
              <div class="year-grid">
                @for (year of yearRange; track year) {
                  <button
                    type="button"
                    class="year-item"
                    [class.selected]="year === viewDate.year()"
                    [class.disabled]="isYearDisabled(year)"
                    [disabled]="isYearDisabled(year)"
                    (click)="selectYear(year, $event)"
                  >
                    {{ year }}
                  </button>
                }
              </div>
            </div>
          }
        }

        <!-- Footer Actions -->
        <div class="calendar-footer">
          @if (selectionMode === 'period') {
            <button type="button" class="btn btn-sm btn-link text-danger" (click)="clearDate()">Clear</button>
          } @else {
            <button type="button" class="btn btn-sm btn-link" (click)="selectToday()">Today</button>
          }

          @if (selectionMode !== 'single' && ((rangeStart && rangeEnd) || selectedDates.length > 0)) {
            <button type="button" class="btn btn-sm btn-link text-secondary" (click)="closeCalendar()">Close</button>
          }

          @if (selectionMode !== 'period') {
            <button type="button" class="btn btn-sm btn-link text-danger" (click)="clearDate()">Clear</button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
